import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { tokens } from "../../../theme";

import { useGridApiRef } from "@mui/x-data-grid";

// import SPOrderDetails from "../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails";
import { useTranslation } from 'react-i18next';
import InboundsView from "./views/Inbounds";

import TabView3 from "../../../components/theme/TabView3/TabView3";
import { relationInboundsConfig } from "./relationInboundsConfig";
import InboundInboundLines from "./views/InboundLines";
import { useTopbar } from "../../../contexts/TopbarProvider";
import InboundTotalsPanel from "../../../components/global/dashboard/InboundTotalsPanel";

const RelationInbound = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    
    const { showExtraTitle,clearExtraTitle } = useTopbar();

    // The totals panel belongs to the All tab, which reports whether it is the one open.
    const [allTabActive, setAllTabActive] = useState(false);

    useEffect(() => {
        showExtraTitle(t("inbound"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])
    

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {ready ?
            <>
                {allTabActive && <InboundTotalsPanel />}

                <TabView3
                    tabConfig={relationInboundsConfig}
                    sx={{
                        background:"green",
                        minHeight: allTabActive ? "calc(100% - 431px)" : "calc(100%)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                >
                    <>
                        <InboundsView config={relationInboundsConfig.inbound} onActiveChange={setAllTabActive}/>
                        <InboundInboundLines config={relationInboundsConfig.inboundLines}/>

                    </>
                </TabView3>


            </>
            :null}
        </Box>
    );
};

export default RelationInbound;